import React from 'react';
import { Redirect } from 'react-router-dom';
import useApp from '../store/app/appContext';
import PrivateRoute from './PrivateRoute';

function AdminRoute({
  component,
  path
}) {
  
  const { appState: { user } } = useApp();

  if (user.user_type === 'staff' || user.user_type === 'root' || user.user_type === 'temp') return (
    <PrivateRoute component={component} path={path}/>
  )
  
  return <Redirect to='/dashboard'/>
  
}

export default AdminRoute
